// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DebugErrorRouteImport } from './routes/debug-error'
import { Route as CancellationRouteImport } from './routes/cancellation'
import { Route as AcceptableUseRouteImport } from './routes/acceptable-use'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as DocsRouteRouteImport } from './routes/docs/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as AuthenticatedUsageRouteImport } from './routes/_authenticated/usage'
import { Route as AuthenticatedOrganizationRouteImport } from './routes/_authenticated/organization'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCredentialsRouteImport } from './routes/_authenticated/credentials'
import { Route as AuthenticatedBillingRouteImport } from './routes/_authenticated/billing'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedAcceptInvitationRouteImport } from './routes/_authenticated/accept-invitation'
import { Route as DocsIndexRouteImport } from './routes/docs/index'
import { Route as DocsSessionsAndLocationsRouteImport } from './routes/docs/sessions-and-locations'
import { Route as DocsApiRouteImport } from './routes/docs/api'
import { Route as DocsSlugRouteImport } from './routes/docs/$slug'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin/users'
import { Route as AuthenticatedAdminSupportRouteImport } from './routes/_authenticated/admin/support'
import { Route as AuthenticatedAdminPoolRouteImport } from './routes/_authenticated/admin/pool'
import { Route as AuthenticatedAdminOrganizationsRouteImport } from './routes/_authenticated/admin/organizations'
import { Route as AuthenticatedAdminInvoicesRouteImport } from './routes/_authenticated/admin/invoices'
import { Route as AuthenticatedAdminIncomeRouteImport } from './routes/_authenticated/admin/income'
import { Route as AuthenticatedAdminEmailsRouteImport } from './routes/_authenticated/admin/emails'
import { Route as AuthenticatedAdminCouponsRouteImport } from './routes/_authenticated/admin/coupons'
import { Route as AuthenticatedAdminContentRouteImport } from './routes/_authenticated/admin/content'
import { Route as AuthenticatedAdminAnnouncementsRouteImport } from './routes/_authenticated/admin/announcements'
import { Route as AuthenticatedAdminSupportChatsRouteImport } from './routes/_authenticated/admin/support_.chats'
import { Route as AuthenticatedAdminOrganizationsOrgIdRouteImport } from './routes/_authenticated/admin/organizations_.$orgId'
import { Route as AuthenticatedAdminContentNewRouteImport } from './routes/_authenticated/admin/content_.new'
import { Route as AuthenticatedAdminContentIdRouteImport } from './routes/_authenticated/admin/content_.$id'
import { Route as AuthenticatedAdminSupportChatsTicketRouteImport } from './routes/_authenticated/admin/support_.chats_.$ticket'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const DebugErrorRoute = DebugErrorRouteImport.update({
            id: '/debug-error',path: '/debug-error',getParentRoute: () => rootRouteImport
          })
const CancellationRoute = CancellationRouteImport.update({
            id: '/cancellation',path: '/cancellation',getParentRoute: () => rootRouteImport
          })
const AcceptableUseRoute = AcceptableUseRouteImport.update({
            id: '/acceptable-use',path: '/acceptable-use',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const DocsRouteRoute = DocsRouteRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedUsageRoute = AuthenticatedUsageRouteImport.update({
            id: '/usage',path: '/usage',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedOrganizationRoute = AuthenticatedOrganizationRouteImport.update({
            id: '/organization',path: '/organization',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCredentialsRoute = AuthenticatedCredentialsRouteImport.update({
            id: '/credentials',path: '/credentials',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedBillingRoute = AuthenticatedBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAcceptInvitationRoute = AuthenticatedAcceptInvitationRouteImport.update({
            id: '/accept-invitation',path: '/accept-invitation',getParentRoute: () => AuthenticatedRoute
          })
const DocsIndexRoute = DocsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DocsRouteRoute
          })
const DocsSessionsAndLocationsRoute = DocsSessionsAndLocationsRouteImport.update({
            id: '/sessions-and-locations',path: '/sessions-and-locations',getParentRoute: () => DocsRouteRoute
          })
const DocsApiRoute = DocsApiRouteImport.update({
            id: '/api',path: '/api',getParentRoute: () => DocsRouteRoute
          })
const DocsSlugRoute = DocsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => DocsRouteRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSupportRoute = AuthenticatedAdminSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPoolRoute = AuthenticatedAdminPoolRouteImport.update({
            id: '/pool',path: '/pool',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminOrganizationsRoute = AuthenticatedAdminOrganizationsRouteImport.update({
            id: '/organizations',path: '/organizations',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminInvoicesRoute = AuthenticatedAdminInvoicesRouteImport.update({
            id: '/invoices',path: '/invoices',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminIncomeRoute = AuthenticatedAdminIncomeRouteImport.update({
            id: '/income',path: '/income',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEmailsRoute = AuthenticatedAdminEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCouponsRoute = AuthenticatedAdminCouponsRouteImport.update({
            id: '/coupons',path: '/coupons',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminContentRoute = AuthenticatedAdminContentRouteImport.update({
            id: '/content',path: '/content',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAnnouncementsRoute = AuthenticatedAdminAnnouncementsRouteImport.update({
            id: '/announcements',path: '/announcements',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSupportChatsRoute = AuthenticatedAdminSupportChatsRouteImport.update({
            id: '/support_/chats',path: '/support/chats',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminOrganizationsOrgIdRoute = AuthenticatedAdminOrganizationsOrgIdRouteImport.update({
            id: '/organizations_/$orgId',path: '/organizations/$orgId',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminContentNewRoute = AuthenticatedAdminContentNewRouteImport.update({
            id: '/content_/new',path: '/content/new',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminContentIdRoute = AuthenticatedAdminContentIdRouteImport.update({
            id: '/content_/$id',path: '/content/$id',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSupportChatsTicketRoute = AuthenticatedAdminSupportChatsTicketRouteImport.update({
            id: '/support_/chats_/$ticket',path: '/support/chats/$ticket',getParentRoute: () => AuthenticatedAdminRoute
          })





const DocsRouteRouteChildren = {
  DocsSlugRoute: DocsSlugRoute,DocsApiRoute: DocsApiRoute,DocsSessionsAndLocationsRoute: DocsSessionsAndLocationsRoute,DocsIndexRoute: DocsIndexRoute
}

const DocsRouteRouteWithChildren = DocsRouteRoute._addFileChildren(DocsRouteRouteChildren)




const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAnnouncementsRoute: AuthenticatedAdminAnnouncementsRoute,AuthenticatedAdminContentRoute: AuthenticatedAdminContentRoute,AuthenticatedAdminCouponsRoute: AuthenticatedAdminCouponsRoute,AuthenticatedAdminEmailsRoute: AuthenticatedAdminEmailsRoute,AuthenticatedAdminIncomeRoute: AuthenticatedAdminIncomeRoute,AuthenticatedAdminInvoicesRoute: AuthenticatedAdminInvoicesRoute,AuthenticatedAdminOrganizationsRoute: AuthenticatedAdminOrganizationsRoute,AuthenticatedAdminPoolRoute: AuthenticatedAdminPoolRoute,AuthenticatedAdminSupportRoute: AuthenticatedAdminSupportRoute,AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminContentIdRoute: AuthenticatedAdminContentIdRoute,AuthenticatedAdminContentNewRoute: AuthenticatedAdminContentNewRoute,AuthenticatedAdminOrganizationsOrgIdRoute: AuthenticatedAdminOrganizationsOrgIdRoute,AuthenticatedAdminSupportChatsRoute: AuthenticatedAdminSupportChatsRoute,AuthenticatedAdminSupportChatsTicketRoute: AuthenticatedAdminSupportChatsTicketRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAcceptInvitationRoute: AuthenticatedAcceptInvitationRoute,AuthenticatedAccountRoute: AuthenticatedAccountRoute,AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedBillingRoute: AuthenticatedBillingRoute,AuthenticatedCredentialsRoute: AuthenticatedCredentialsRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedOrganizationRoute: AuthenticatedOrganizationRoute,AuthenticatedUsageRoute: AuthenticatedUsageRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,DocsRouteRoute: DocsRouteRouteWithChildren,AuthenticatedRoute: AuthenticatedRouteWithChildren,AcceptableUseRoute: AcceptableUseRoute,CancellationRoute: CancellationRoute,DebugErrorRoute: DebugErrorRoute,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SignupRoute: SignupRoute,SupportRoute: SupportRoute,TermsRoute: TermsRoute,BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)